import { EntityService } from '../EntityService';

export class RegisterInvoiceService extends EntityService {

  static entity = 'api/app/template-security';

  static getInvoiceSettings(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/tenant-invoice-settings/${id}`).then(res => res.data);
  }

  static getUsingOfYearList(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/using-of-year-list`, { params }).then(res => res.data);
  }

  static getUsingList(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/using-list`, { params }).then(res => res.data);
  }

  static getPermisionList(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/using-permission`, { params }).then(res => res.data);
  }

  static getInvoiceSerialByYear(): Promise<any> {
    return this.axios.get(`${this.entity}/invoice-serial-by-year`).then(res => res.data);
  }

  static copyRegisterInvoice(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/copy-register-invoice`, data).then(res => res.data);
  }

}
